"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmAccordionItem = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const classnames_1 = __importDefault(require("classnames"));
const useAccordion_1 = require("./useAccordion");
const Icon_1 = require("../Icon");
exports.SmAccordionItem = react_1.default.forwardRef((_a, ref) => {
    var { title, subtitle, imageURL, imageALT, components, className, children } = _a, props = __rest(_a, ["title", "subtitle", "imageURL", "imageALT", "components", "className", "children"]);
    const { text, prefix } = (0, useAccordion_1.useAccordionComponents)({
        title,
        subtitle,
        components,
        imageURL,
        imageALT,
    });
    const context = react_1.default.useContext(useAccordion_1.AccordionContext);
    const itemRef = react_1.default.useRef(null);
    const buttonId = react_1.default.useMemo(() => {
        return props.id || `${context === null || context === void 0 ? void 0 : context.accordionId}-${(0, lodash_1.uniqueId)('button-')}`;
    }, [context === null || context === void 0 ? void 0 : context.accordionId, props.id]);
    const panelId = react_1.default.useMemo(() => {
        return `${context === null || context === void 0 ? void 0 : context.accordionId}-${(0, lodash_1.uniqueId)('panel-')}`;
    }, [context === null || context === void 0 ? void 0 : context.accordionId]);
    const isActive = react_1.default.useMemo(() => {
        if (typeof (context === null || context === void 0 ? void 0 : context.activeIndex) === 'object' &&
            (context.index || context.index === 0) &&
            context.activeIndex) {
            const array = context.activeIndex;
            return array.includes(context.index) && !props.disabled;
        }
        return (context === null || context === void 0 ? void 0 : context.activeIndex) === (context === null || context === void 0 ? void 0 : context.index) && !props.disabled;
    }, [context === null || context === void 0 ? void 0 : context.index, context === null || context === void 0 ? void 0 : context.activeIndex]);
    const buttonClassname = (0, classnames_1.default)('c-accordion__button', className);
    return (react_1.default.createElement("div", { className: "c-accordion__item", ref: itemRef },
        react_1.default.createElement("h3", null,
            react_1.default.createElement("button", Object.assign({}, props, { type: "button", "aria-expanded": isActive, className: buttonClassname, "aria-controls": panelId, "aria-label": title, id: buttonId, ref: ref, onFocus: (e) => {
                    var _a, _b;
                    if (!props.disabled) {
                        (_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('-focused');
                        (_b = props.onFocus) === null || _b === void 0 ? void 0 : _b.call(props, e);
                    }
                }, onBlur: (e) => {
                    var _a, _b;
                    if (!props.disabled) {
                        (_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('-focused');
                        (_b = props.onBlur) === null || _b === void 0 ? void 0 : _b.call(props, e);
                    }
                }, onMouseEnter: (e) => {
                    var _a, _b;
                    if (!props.disabled) {
                        (_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('-mouseover');
                        (_b = props.onMouseEnter) === null || _b === void 0 ? void 0 : _b.call(props, e);
                    }
                }, onMouseLeave: (e) => {
                    var _a, _b;
                    if (!props.disabled) {
                        (_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('-mouseover');
                        (_b = props.onMouseLeave) === null || _b === void 0 ? void 0 : _b.call(props, e);
                    }
                }, onClick: (e) => {
                    var _a, _b;
                    (_a = context === null || context === void 0 ? void 0 : context.changePanel) === null || _a === void 0 ? void 0 : _a.call(context);
                    (_b = props.onClick) === null || _b === void 0 ? void 0 : _b.call(props, e);
                } }),
                react_1.default.createElement("div", { className: "c-accordion__content" },
                    prefix,
                    text),
                react_1.default.createElement("div", { className: "c-accordion__extra" }, components === null || components === void 0 ? void 0 :
                    components.extra,
                    react_1.default.createElement(Icon_1.SmIcon, { name: "expand_more", className: isActive ? '-active' : '' })))),
        react_1.default.createElement("div", { id: panelId, role: "region", "aria-labelledby": buttonId, className: "c-accordion__panel", hidden: !isActive }, !props.disabled && children)));
});
//# sourceMappingURL=SmAccordionItem.js.map